module.exports = __webpack_public_path__ + "assets/img/9_80_big.2bffcb13.jpg";